import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface Testimonial {
  name: string;
  role: string;
  quote: string;
  initials: string;
  color: string;
}
export function Testimonials() {
  const testimonials: Testimonial[] = [{
    name: 'Florencia M.',
    role: 'Psicopedagoga · Córdoba',
    quote: 'Compré el Mega Pack de Dislexia y me salvó las planificaciones. Antes me quedaba hasta cualquier hora armando fichas en Canva. Ahora imprimo y ya tengo la sesión estructurada. Las familias notan el avance mucho más rápido.',
    initials: 'FM',
    color: 'bg-[#c87b5a]'
  }, {
    name: 'Mariana R.',
    role: 'Fonoaudióloga · Buenos Aires',
    quote: 'El Sistema de Tartamudez es oro puro. Es muy difícil encontrar material clínico serio y organizado por edades en español. Entro a cada sesión con una tranquilidad que antes no tenía.',
    initials: 'MR',
    color: 'bg-[#1f3d36]'
  }, {
    name: 'Lucía G.',
    role: 'Psicóloga Infantil · Rosario',
    quote: 'Uso el Mega Pack Terapéutico todos los días. Los registros clínicos que trae me organizaron la vida. Ya no improviso ni me desgasto pensando qué hacer con cada paciente.',
    initials: 'LG',
    color: 'bg-[#2d4a3e]'
  }, {
    name: 'Andrea V.',
    role: 'Maestra de Apoyo · Mendoza',
    quote: 'El material de Inclusión en el Aula es exactamente lo que necesitaba. Me permite adaptar el contenido para mis alumnos con TDAH y TEA sin tener que rehacer todo desde cero. ¡Gracias!',
    initials: 'AV',
    color: 'bg-[#c87b5a]'
  }, {
    name: 'Sofía L.',
    role: 'Neurolingüista · La Plata',
    quote: 'El Kit Clínico Cognitivo tiene un nivel de detalle increíble. Trabajo funciones ejecutivas con un criterio claro y los chicos se enganchan un montón con las actividades.',
    initials: 'SL',
    color: 'bg-[#1f3d36]'
  }];
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-77">
      <div className="max-w-7xl mx-auto px-6 md:px-8" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-79">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-primary mb-4 font-serif" data-id="element-80">
            Lo que dicen las profesionales que ya usan Intervención Digital
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-81">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-brand-bg rounded-2xl p-8 shadow-sm border border-brand-bgAlt flex flex-col" data-id="element-82">
              <div className="flex text-yellow-400 mb-4" data-id="element-83">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-84" />)}
              </div>

              <p className="text-gray-700 italic mb-6 flex-grow leading-relaxed" data-id="element-85">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-86">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-lg ${testimonial.color}`} data-id="element-87">
                  {testimonial.initials}
                </div>
                <div data-id="element-88">
                  <h4 className="font-bold text-brand-primary" data-id="element-89">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-90">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}